'use client';

import { useParams, useSearchParams } from 'react-router-dom';
import GameSearchPage from '../../components/game-search-page';
import { useRegisteredGame } from '../use-registered-game';

/**
 * SPA 搜索：`/:game/search?q=`，复用 GameSearchPage。
 */
export default function SpaSearchPage() {
  const params = useParams();
  const [searchParams] = useSearchParams();
  const gameParam = String(params.game || '');
  const initialQuery = searchParams.get('q') || '';
  const registered = useRegisteredGame(gameParam);

  if (registered.status === 'loading') {
    return (
      <main className="spa-boot" aria-busy="true">
        <p className="spa-boot-status" />
      </main>
    );
  }

  if (registered.status === 'error') {
    return (
      <main className="spa-boot" role="alert">
        <h1>加载失败</h1>
        <p>{registered.message}</p>
        <p>
          <a href="/">返回首页</a>
        </p>
      </main>
    );
  }

  const gameKey = registered.game.key || gameParam;
  const domain = registered.game.domain || gameParam;

  return (
    <GameSearchPage
      key={gameKey}
      gameKey={gameKey}
      gameDomain={domain}
      gameName={registered.game.name || gameParam}
      initialQuery={initialQuery}
      initialItems={[]}
    />
  );
}
